import { useContext } from "react";
import { StripeContext } from "./StripeContext";

/**
 * Custom hook to access Stripe subscription data from context.
 * Must be used within a <StripeWrapper>.
 *
 * @returns {import("./StripeContext").StripeContextValue}
 * @throws {Error} If used outside of <StripeWrapper>
 */
export const useStripe = () => {
  const ctx = useContext(StripeContext);
  if (!ctx) {
    throw new Error("useStripe must be used within <StripeWrapper>");
  }
  return ctx;
};
